import React from 'react';
import PropTypes from 'prop-types';
import ConfigurableRangeFilter from './ConfigurableRangeFilter';
import { createUtrConfig } from './rangeConfigs';

const RatingFilter = ({ isPickleball, min, max, onChange, className }) => {
  const utrConfig = createUtrConfig(isPickleball);
  const title = isPickleball ? 'UTR-P Rating' : 'UTR Rating';

  return (
      <ConfigurableRangeFilter
          title={title}
          min={min}
          max={max}
          onChange={onChange}
          className={className}
          config={utrConfig}
      />
  );
};

RatingFilter.propTypes = {
  isPickleball: PropTypes.bool,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

RatingFilter.defaultProps = {
  isPickleball: false,
  onChange: () => {},
  className: '',
};

export default RatingFilter;
